import type { ClerkProviderProps } from '@clerk/clerk-react'

type Appearance = NonNullable<ClerkProviderProps['appearance']>

/** Applies to the few surfaces Clerk still renders itself — currently just the reverification
 *  modal (the password re-check before enabling/disabling 2FA; see useReverification() in
 *  EnableTotpPage/DisableTotpPage). Referencing the --fl-* custom properties directly, rather
 *  than copying in their hex values, means this tracks the light/dark theme toggle automatically
 *  — Clerk's modal renders into the same document, so it sees the same CSS variables. */
export const clerkAppearance: Appearance = {
  variables: {
    colorPrimary: 'var(--fl-primary)',
    colorPrimaryForeground: 'var(--fl-primary-fg)',
    colorBackground: 'var(--fl-surface)',
    colorForeground: 'var(--fl-heading)',
    colorTextSecondary: 'var(--fl-text-2)',
    colorInputBackground: 'var(--fl-surface)',
    colorInputForeground: 'var(--fl-heading)',
    colorDanger: 'var(--fl-error)',
    colorMuted: 'var(--fl-text-3)',
    colorBorder: 'var(--fl-border)',
    borderRadius: '0.5rem',
    fontFamily: 'Inter, system-ui, sans-serif',
  },
}
